<template>
    <div class="o-vacancies-single-listing">
        <div class="o-vacancies-single-listing__meta">
            <h3 class="o-vacancies-single-listing__title">{{ job.name }}</h3>
            <p class="o-vacancies-single-listing__location">{{ job.practice_name }} - {{ job.location }}</p>
        </div>
        <div class="o-vacancies-single-listing__actions">
            <a class="o-vacancies-single-listing__view-button" :href="job.link" :title="$t('vacancies.view_more')">
                {{ $t("vacancies.view_more") }}
            </a>
            <a class="o-vacancies-single-listing__apply-button" :href="job.apply_now" :title="$t('vacancies.apply_now')">
                {{ $t("vacancies.apply_now") }}
            </a>
        </div>
    </div> 
</template>
<script>
    import vacanciesMixin from "../../../mixins/vacancies";

    export default {
        name: 'VacanciesList',
        props: ['job'],
        mixins: [vacanciesMixin],
        
        data() {
            return {
            }
        }
    }
</script>